// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"2":"8c8f7e4d","16":"406b30c9","66":"608813a8","236":"99e7d025","374":"7f4ce688","440":"72091479","786":"d79d50c6","806":"677bfdbf"}[chunkId] + ".css";
};